/**
 * Checks if the current site needs product dialogs
 * @return {Promise<void>}
 */
export async function checkForDialog() {
    const buttons = document.querySelectorAll('[data-open-dialog]')

    if (buttons.length) {
        const dialog = await import('./PopUp')

        dialog.default()
    }
}

/**
 * Checks for DocCheck protection popup
 * @return {Promise<void>}
 */
export async function checkForDocCheckPopUp() {
    const docCheck = document.querySelectorAll('.doc-check');

    if (docCheck.length) {
        const docCheckPopUp = await import('./PopUp/DocCheck');
        docCheckPopUp.default();
    }
}

/**
 * Checks if the current page has a FriendlyCaptcha widget — migrated to the
 * v2 "@friendlycaptcha/sdk" package (2026-10-21; v1's "friendly-challenge"
 * was end-of-lifed account-side). Unlike v1's "friendly-challenge/widget",
 * which self-initialized on import via its own DOMContentLoaded listener,
 * v2's SDK has no such side-effecting import - attach() must be called
 * explicitly, which is also what actually scans the page for `.frc-captcha`
 * elements and mounts a widget on each one found.
 * @return {Promise<void>}
 */
export async function checkForCaptcha() {
    const captcha = document.querySelectorAll('.frc-captcha');

    if (captcha.length) {
        const { FriendlyCaptchaSDK } = await import('@friendlycaptcha/sdk');
        new FriendlyCaptchaSDK().attach();
    }
}

/**
 * Checks if the current page has a searchable select (SlimSelect) —
 * previously a static top-level import in main.js, shipping the library on
 * every page regardless of whether a `.searchable-select` element exists.
 * @return {Promise<void>}
 */
export async function checkForSlimSelect() {
    const select = document.querySelectorAll('.searchable-select');

    if (select.length) {
        const InitSlimSelect = await import('./SlimSelect');
        InitSlimSelect.default();
    }
}
